import {Injectable} from '@angular/core';
import {PersistentTabStore, TabWithID} from '@app/core/state/persistent-tab/persistent-tab.store';
import {Tab} from '@app/shared/tab-bar/tab-bar.component';
import {Observable} from 'rxjs';
import {
  deleteEntities,
  getActiveEntity,
  getActiveId,
  getAllEntities,
  getEntity,
  moveEntity,
  selectActiveEntity,
  selectActiveId,
  selectAllEntities,
  setActiveId,
  upsertEntities
} from "@ngneat/elf-entities";

@Injectable({providedIn: 'root'})
export class PersistentTabService {

  private previousActiveTab: Tab;

  constructor(private persistentTabStore: PersistentTabStore) {
  }

  clearPersistentTabStore() {
    this.persistentTabStore.data.reset();
  }

  getTab(id: string): Tab {
    return this.persistentTabStore.data.query(getEntity(id));
  }

  getTabIDForURL(url: string): string {
    const tabs = this.getTabs();
    if (tabs && url) {
      return tabs.find(t => t.idURL && url.startsWith(t.idURL)) ? tabs.find(t => url.startsWith(t.idURL)).idURL : null;
    }
    return null;
  }

  getTabs(): Tab[] {
    return this.persistentTabStore.data.query(getAllEntities());
  }

  getTabs$(): Observable<Tab[]> {
    return this.persistentTabStore.data.pipe(selectAllEntities());
  }

  addTab(tab: Tab, setActive = true): void {
    const currentTabs = this.getTabs();
    const isNewTabInList = currentTabs && (currentTabs.findIndex(v => v.idURL === tab.idURL) === -1);

    let storeTab: Partial<TabWithID> = {};
    storeTab = Object.assign(tab, storeTab)
    storeTab.id = tab.idURL;
    this.persistentTabStore.data.update(upsertEntities(storeTab));

    if (isNewTabInList && this.previousActiveTab) {
      const previousIndex = currentTabs.findIndex(v => v.idURL === this.previousActiveTab.idURL);
      const newTabIndex = this.getTabs()
        .findIndex(v => v.idURL === tab.idURL);
      if (previousIndex !== -1 && newTabIndex !== -1) { // den aktuelle eingefügten tab, rechts neben den davor aktiven tab schieben
        this.persistentTabStore.data.update(moveEntity({fromIndex: newTabIndex, toIndex: previousIndex + 1}));
      }
    }
    if (setActive) {
      this.setActive(tab.idURL);
    }
  }

  removeTab(tab: Tab): void {
    this.persistentTabStore.data.update(deleteEntities(tab.idURL));
  }

  moveTab(fromIdx: number, toIdx: number): void {
    this.persistentTabStore.data.update(moveEntity({fromIndex: fromIdx, toIndex: toIdx}));
  }

  isActive(tab: Tab): boolean {
    const id = this.persistentTabStore.data.query(getActiveId);
    return id && tab.idURL === id;
  }

  setActive(id: string): void {
    this.previousActiveTab = this.persistentTabStore.data.query(getActiveEntity());
    this.persistentTabStore.data.update(setActiveId(id));
  }

  getActiveTab(): Tab {
    return this.persistentTabStore.data.query(getActiveEntity());
  }

  getActiveTab$(): Observable<Tab> {
    return this.persistentTabStore.data.pipe(selectActiveEntity());
  }

  getActiveId$(): Observable<string> {
    return this.persistentTabStore.data.pipe(selectActiveId());
  }

}
